import React, { useState } from "react";
import PropTypes from "prop-types";
import { HeroWrapper } from "./style";
import { CtaButton } from "../../Elements";
import { CloudinaryImage } from "@website-builder/ui/shared/elements";
import ReactPlayer from "react-player/youtube";
import VideoModal from "./VideoModal";

const HeroWithVideo = (props) => {
	const {
		header,
		description,
		fontColor,
		showInTabletAndMobile,
		cta,
		video,
		externalDependency,
	} = props;

	const [show, setShow] = useState(false);
	const [url, seturl] = useState();
	const [videoArray, setUpdatedArray] = useState(video);
	const [videoUrl, setUpdatedUrl] = useState(video[0]?.videoUrl?.url);
	const [videoText, setUpdatedText] = useState(video[0]?.videoImage?.altTag);

	const handleButtonClicked = (url, text) => {
		let videoUrl = url;
		setUpdatedUrl(videoUrl);
		let videoText = text;
		setUpdatedText(videoText);
	};

	return (
		<HeroWrapper
			fontColor={fontColor}
			showInTabletAndMobile={showInTabletAndMobile}
		>
			<div className="joinusWrapper">
				<h2 className="header">{header}</h2>
				<div
					className="description"
					dangerouslySetInnerHTML={{ __html: description }}
				></div>
				{cta && (
					<CtaButton
						cta={cta}
						Link={externalDependency?.Link}
						className="join-button"
					/>
				)}
			</div>
			<div className="imageWrapper">
				<ReactPlayer className="videoContainer" url={videoUrl} controls />
				<div className="videoDesc">{videoText}</div>
				<div className="thumbNailContainer">
					{videoArray.map((video) => (
						<div
							key={video.videoImage.image}
							className="thumbNail"
							onClick={() =>
								handleButtonClicked(video.videoUrl.url, video.videoImage.altTag)
							}
						>
							<CloudinaryImage
								lazyload
								url={video.videoImage.image}
								sizes={{
									default: {
										height: 190,
									},
								}}
							/>
						</div>
					))}
				</div>
			</div>
			<div className="mobileContainer">
				{videoArray.map((video) => (
					<div
						key={video.videoImage.image}
						className="mobileThumbnail"
						onClick={() => setShow(true)}
					>
						<span onClick={() => seturl(video.videoUrl.url)}>
							<CloudinaryImage
								lazyload
								url={video.videoImage.image}
								sizes={{
									default: {
										height: 190,
									},
								}}
							/>
						</span>
					</div>
				))}
			</div>
			<VideoModal
				show={show}
				url={url}
				onClose={() => setShow(false)}
			></VideoModal>
		</HeroWrapper>
	);
};

HeroWithVideo.propTypes = {
	header: PropTypes.string,
	description: PropTypes.string,
	fontColor: PropTypes.string,
	showInTabletAndMobile: PropTypes.bool,
	uRLvalue: PropTypes.string,
	cta: PropTypes.shape({
		link: PropTypes.shape({
			type: PropTypes.oneOf(["hash", "external", "internal"]),
			value: PropTypes.string,
		}),
		color: PropTypes.string,
		type: PropTypes.oneOf(["solid", "outline"]),
		text: PropTypes.string,
	}),
	video: PropTypes.array,
};

HeroWithVideo.defaultProps = {
	header: "",
	description: "",
	fontColor: "#ffffff",
	showInTabletAndMobile: true,
	uRLvalue: "https://www.youtube.com/watch?v=pwPNOQi0ZNM&feature=youtu.be",
	cta: null,
	video: [],
};

export default HeroWithVideo;
